/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_SendInputs */

const en_admin_ai_chat_send = /** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const de_admin_ai_chat_send = /** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const es_admin_ai_chat_send = /** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const fr_admin_ai_chat_send = /** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const nl_admin_ai_chat_send = /** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versturen`)
};

/** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */
const it_admin_ai_chat_send = en_admin_ai_chat_send;

/** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_send = en_admin_ai_chat_send;

/** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */
const pl_admin_ai_chat_send = en_admin_ai_chat_send;

/** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */
const hu_admin_ai_chat_send = en_admin_ai_chat_send;

/** @type {(inputs: Admin_Ai_Chat_SendInputs) => LocalizedString} */
const ro_admin_ai_chat_send = en_admin_ai_chat_send;

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Admin_Ai_Chat_SendInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_send = /** @type {((inputs?: Admin_Ai_Chat_SendInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_SendInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_send(inputs)
	if (locale === "de") return de_admin_ai_chat_send(inputs)
	if (locale === "es") return es_admin_ai_chat_send(inputs)
	if (locale === "fr") return fr_admin_ai_chat_send(inputs)
	if (locale === "nl") return nl_admin_ai_chat_send(inputs)
	if (locale === "it") return it_admin_ai_chat_send(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_send(inputs)
	if (locale === "pl") return pl_admin_ai_chat_send(inputs)
	if (locale === "hu") return hu_admin_ai_chat_send(inputs)
	return ro_admin_ai_chat_send(inputs)
});
export { admin_ai_chat_send as "admin.ai_chat.send" }